import React from 'react'

import { useWhyWeInvest } from './hooks/use-why-we-invest'
import { WhyWeInvestTemplate } from './template'

const WhyWeInvest = (): React.JSX.Element => {
  const state = useWhyWeInvest()

  return <WhyWeInvestTemplate state={state} />
}

export default WhyWeInvest
